/*
 * @Description:
 * @Author: fiveonelei
 * @Date: 2022-02-10 11:16:11
 * @FilePath: /vise/packages/app-share/src/constants/mini-app.ts
 */
export enum EMiniAppPosition {
  videoLike = 'video_like',
  videoComment = 'video_comment',
  videoHeadpicFocus = 'video_headpic_focus',
  videoHeadpic = 'video_headpic',
  open = 'open',
  video = 'video',
  recommendOpen = 'recommend_open',
  recommendVideo = 'recommend_video',
  jumpWeishi = 'jump_weishi',
}

export const MINIAPPPATHS = {
  [EMiniAppPosition.videoLike]: '/pages/feed/feed',
  [EMiniAppPosition.videoComment]: '/pages/feed/feed',
  [EMiniAppPosition.videoHeadpicFocus]: '/pages/new-personal/new-personal',
  [EMiniAppPosition.videoHeadpic]: '/pages/new-personal/new-personal',
  [EMiniAppPosition.open]: '/pages/feed/feed',
  [EMiniAppPosition.video]: '/pages/feed/feed',
  [EMiniAppPosition.recommendOpen]: 'pages/home/index',
  [EMiniAppPosition.recommendVideo]: '/pages/feed/feed',
  [EMiniAppPosition.jumpWeishi]: 'pages/home/index',
};

